import React from 'react';
import { Section, FieldGrid, IdTile, Button, TrailLink } from '../../components/EntityList';
import { useLabels } from '../../hooks/useLabels';
import { showCurrency } from '../../utils';

const hasValue = (value) => value !== undefined && value !== null && value !== '';
const hasMoneyValue = (value) => hasValue(value) && Number(value) !== 0;

function formatAmount(asset, value) {
	if (!hasMoneyValue(value)) {
		return null;
	}
	const amount = Number(value);
	if (Number.isNaN(amount)) {
		return null;
	}
	const currency = showCurrency(asset.currency) || asset.currency || '';
	return `${currency} ${amount.toLocaleString('es-UY')}`.trim();
}

function AssetInfo({ asset }) {
	const { t } = useLabels();

	if (!asset) {
		return null;
	}

	const folderValue = (
		<>
			{hasValue(asset.folder) && asset.folder}
			{asset.escritura && (
				<Button size='sm' onClick={() => window.open(asset.escritura.fileLink, '_blank', 'noopener,noreferrer')}>
					{t('action.viewEscritura')}
				</Button>
			)}
		</>
	);

	const left = [
		{ label: t('field.name'), value: asset.name, required: true },
		{ label: t('field.type'), value: asset.type },
		{ label: t('form.multipleLotsQ'), value: asset.multipleLots ? t('form.yes') : t('form.no') },
		{ label: t('field.sold'), value: asset.sold ? t('form.yes') : t('form.no') },
		{
			label: t('entity.assetOwner'),
			value: asset.owner ? (
				<TrailLink to={`/AdminScreen/accounts/account/${asset.owner._id || asset.owner}`}>{asset.owner.name}</TrailLink>
			) : (
				t('msg.noOwnerAssigned')
			),
		},
		{ label: t('field.folder'), value: folderValue },
		{ label: t('field.observations'), value: asset.observations, area: true },
	];

	const right = [
		{ label: t('field.price'), value: formatAmount(asset, asset.price), mono: true },
		{ label: t('field.ubicationPlain'), value: asset.ubication },
		{ label: t('field.housingUnit'), value: asset.housingUnit, mono: true },
		{ label: t('field.lotUpper'), value: asset.lot, mono: true },
		{ label: t('field.currency'), value: asset.currency, mono: true },
		{ label: t('field.totalGuaranteed'), value: formatAmount(asset, asset.guaranteedAmount), mono: true },
		{ label: t('field.descriptionPlain'), value: asset.description, area: true },
	];

	return (
		<Section title={t('title.details')}>
			<FieldGrid left={left} right={right} />
			<div className='tw:mt-4 tw:flex tw:items-center tw:gap-2 tw:border-t tw:border-border tw:pt-4'>
				{asset.responsible ? (
					<>
						<IdTile name={asset.responsible.name} size={22} shape='circle' />
						<span className='tw:text-[13.5px] tw:text-ink-0'>{asset.responsible.name}</span>
					</>
				) : (
					<span className='tw:text-[13.5px] tw:text-ink-3'>{t('msg.noResponsibleAssigned')}</span>
				)}
			</div>
		</Section>
	);
}

export default AssetInfo;
